import { styles } from '../globals/map-styles';

const google = window.google;
let map, directionsService, directionsRenderer, geocoder;
let markers = [];

function calculateDirections(pointA, pointB) {
  directionsService.route({
    origin: pointA,
    destination: pointB,
    travelMode: google.maps.TravelMode.DRIVING,
  }, function (response, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsRenderer.setDirections(response);
    }
  })
}

export default {
  init() {
    const $mapWrap = $('.location-map-section');
    const $locationMap = $('#location-map');

    function initMap() {
      directionsService = new google.maps.DirectionsService();
      directionsRenderer = new google.maps.DirectionsRenderer();
      geocoder = new google.maps.Geocoder();

      map = new google.maps.Map($locationMap.get()[0], {
        center: {
          lat: -34.397,
          lng: 150.644,
        },
        styles: styles,
        zoom: 16,
      });

      directionsRenderer.setMap(map);

      // add markers
      $('.locations-row .location').each(function () {
        var coordLat = parseFloat($(this).data('lat'));
        var coordLong = parseFloat($(this).data('long'));
        const officeTitle = $(this).find('.location-box .name').html();

        markers[$(this).data('uid')] = new google.maps.Marker({
          position: {
            lat: coordLat,
            lng: coordLong,
          },
          map: map,
          title: officeTitle,
        });
      });

    }

    $(document).ready(function () {
      $mapWrap.hide();
      initMap();
    });

    $('.map-view').each(function () {
      $(this).on('click', function () {
        var coordLat = parseFloat($(this).closest('.location').data('lat'));
        var coordLong = parseFloat($(this).closest('.location').data('long'));

        map.setCenter({
          lat: coordLat,
          lng: coordLong,
        });

        map.setZoom(16);

        $mapWrap.data('current-uid', $(this).closest('.location').data('uid'));

        $mapWrap.stop().slideDown();
      });
    });
  },
  finalize() {
    $('#direction-form').on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const userInput = $(this).find('input[name="direction-entry"]').val();
      let coordLat, coordLong;

      geocoder.geocode({
        'address': userInput,
      }, function (results, status) {
        if (status == 'OK') {
          if (results[0] && results[0].geometry && results[0].geometry.bounds) {

            const bounds = results[0].geometry.bounds;
            const boundA = bounds[Object.keys(bounds)[0]];
            const boundB = bounds[Object.keys(bounds)[1]];

            var boundLat = 0;
            var boundLon = 0;

            if (boundA > 0) {
              boundLat = boundB;
              boundLon = boundA;
            } else {
              boundLat = boundA;
              boundLon = boundB;
            }

            coordLat = (boundLat.i + boundLat.j) / 2;
            coordLong = (boundLon.i + boundLon.j) / 2;

            calculateDirections(coordLat.toString() + ', ' + coordLong.toString(), markers[$('.location-map-section').data('current-uid')].getPosition());
          } else {
            alert('Could not resolve location');
          }
        } else {
          alert('Could not find location: ' + status);
        }
      });
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-contact.js